/**
 * Get the API base URL
 * Uses window.__BACKEND_URL__ which is set in index.html before React loads
 * - In production (custom domains), returns empty string for relative URLs
 * - In development/preview, returns the configured dev URL
 */
export function getBackendUrl() {
  // Use the global variable set in index.html
  if (typeof window !== 'undefined' && window.__BACKEND_URL__ !== undefined) {
    return window.__BACKEND_URL__;
  }
  
  // Use environment variable if available
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    return envUrl;
  }
  
  // Fallback - check hostname manually
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isDevelopment = hostname === 'localhost' || hostname === '127.0.0.1';
    // Production: use relative URLs
    return isDevelopment ? '' : '';
  }
  
  return '';
}

// For backwards compatibility
export default getBackendUrl;

// Alias - computed at module load time
export const API_BASE_URL = typeof window !== 'undefined' && window.__BACKEND_URL__ !== undefined 
  ? window.__BACKEND_URL__ 
  : '';
